<template>
  <Popover v-if="solutions.length" v-slot="{ close }" class="relative">
    <PopoverButton
      class="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-contrast-primary active:scale-95 active:bg-primary-400 dark:bg-primary-700 dark:active:bg-primary-600"
    >
      <font-awesome-icon :icon="['fal', 'plus']" size="lg" />
    </PopoverButton>
    <Transition
      enter-active-class="transform duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transform duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <PopoverPanel
        class="absolute left-0 z-10 mt-3 w-screen max-w-sm transform px-4 sm:px-0 lg:w-72"
      >
        <div class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5">
          <div class="relative grid gap-8 bg-white p-5">
            <router-link
              v-for="item in solutions"
              :key="item.name"
              :to="item.to"
              @click="close()"
              class="-m-3 flex items-center rounded-lg p-1 hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-orange-500/50"
            >
              <div
                class="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-theme-23 text-gray-700 sm:h-8 sm:w-8"
              >
                <font-awesome-icon :icon="['fal', item.icon]" size="lg" />
              </div>
              <div class="ml-4">
                <p class="text-sm font-medium text-gray-900 capitalize">
                  {{ item.name }}
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </PopoverPanel>
    </Transition>
  </Popover>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  Popover,
  PopoverPanel,
  PopoverButton,
  PopoverOverlay
} from '@headlessui/vue'

export default {
  components: { Popover, PopoverPanel, PopoverButton, PopoverOverlay },
  name: 'QuickAdd',
  computed: {
    ...mapGetters({
      authRole: 'auth/getAuthRole',
      settings: 'settings/getSystemSettings'
    }),
    isCustomerUser() {
      return this.authRole === 'customer-user'
    },
    // Document types the crematorium issues (invoicing settings).
    availableDocs() {
      return Object.values(this.settings?.invoicing?.available_docs ?? {})
    },
    canCreateDocument() {
      return !this.isCustomerUser && this.$can('manage_invoicing')
    },
    solutions() {
      return [
        {
          name: this.$t('navigation.work_new'),
          to: { name: 'work_form_new_route' },
          icon: 'user',
          gate: this.$can('manage_work')
        },
        {
          name: this.$t('global.invoicing_title.INV'),
          to: { name: 'invoice_form_new_route' },
          icon: 'file',
          gate: this.canCreateDocument && this.availableDocs.includes('INV')
        },
        {
          name: this.$t('global.invoicing_title.PO'),
          to: { name: 'invoicing_purchase_order_new_route' },
          icon: 'file',
          gate: this.canCreateDocument && this.availableDocs.includes('PO')
        },
        {
          name: this.$t('global.invoicing_title.QUO'),
          to: { name: 'invoicing_quote_new_route' },
          icon: 'file',
          gate: this.canCreateDocument && this.availableDocs.includes('QUO')
        },
        {
          name: this.$t('global.invoicing_title.CR'),
          to: { name: 'report_planning_route' },
          icon: 'file-pdf',
          gate: !this.isCustomerUser && this.$can('see_planning')
        }
      ].filter((item) => item.gate)
    }
  }
}
</script>
